const getTitleMenuMenu = (t) => [
    {
        name: t('menu-menu-title-menu'),
        linkForRoute: "menu"
    },
    {
        name: t('menu-menu-title-7-day-menu'),
        linkForRoute: "7-day-menu"
    },
    {
        name: t('menu-menu-title-available-dishes'),
        linkForRoute: "available-dishes"
    },
    {
        name: t('menu-menu-title-sample-menu'),
        linkForRoute: "sample-menu"
    },
]

export {
    getTitleMenuMenu
}